export default __webpack_public_path__ + "static/media/lato-black.6d835b99.woff2";